import React, { useState, createContext } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Banner from './components/Banner/Banner';
import InitialForm from './components/InitialForm';
import GetUrlPage from './components/GetUrlPage';
import ClientNavigation from './components/ClientNavigation';
import { ProductSelected } from './hooks/contexts';
import { GS1 } from './services/api';
import SpecialClientNavigation from './components/SpecialClientNavigation/SpecialClientNavigation';


import 'bootstrap';
import './styles/general.scss';
import config from './services/env';


const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#003670',
        },
        secondary: {
            main: '#23c00b',
        },
    }
})


const defaultProductsStatus = {
    "isTc": false,
    "isIsv": false,
    "isSupplai": false,
    "isMks": false,
}


const App = () => {
    const [hasToReturn, setHasToReturn] = useState(true);
    const [hasConfidentialityReturn, setAccessToReturn] = useState(false);
    const [productsStatus, setProductsStatus] = useState(defaultProductsStatus);

    return (
        <div className="background-content">
            <ThemeProvider theme={theme}>
                <ProductSelected.Provider value={{productsStatus, setProductsStatus}}>
                    <BrowserRouter>
                        <Container>
                            <Banner {...{ hasToReturn, setAccessToReturn }}/>
                            <Switch>
                                <Route path="/start-form" component={InitialForm} />
                                <Route path="/get-client-url/:hashCode" component={GetUrlPage} />
                                <Route path={`/clientes/gs1-b2b-keys`}
                                    render={(props) => (
                                        <SpecialClientNavigation
                                            hash={config.GS1}
                                            setHasToReturn={(status) => setHasToReturn(status)}
                                            setAccessToReturn={(accessReturn) => setAccessToReturn(accessReturn)}
                                            hasConfidentialityReturn={hasConfidentialityReturn}
                                        />
                                    )}
                                />
                                <Route
                                    path="/clientes/:hashCode"
                                    render={(props) => (
                                        <ClientNavigation
                                            match={props.match}
                                            setHasToReturn={(status) => setHasToReturn(status)}
                                            setAccessToReturn={(accessReturn) => setAccessToReturn(accessReturn)}
                                            hasConfidentialityReturn={hasConfidentialityReturn}
                                        />
                                    )}
                                />
                            </Switch>
                        </Container>
                    </BrowserRouter>
                </ProductSelected.Provider>
            </ThemeProvider>
        </div>
    );
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.unregister();
